import type { Capability } from '@taler/api-client'

/** Forgiving a contact's receivable is a contact write, same gate as editing one. */
export function canForgiveContact(can: (capability: Capability) => boolean): boolean {
  return can('RECORDS_MANAGE')
}
